import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history', // 可选，去除URL中的#
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    // 可扩展其他页面路由（如about、news等）
    {
      path: '/about',
      name: 'About',
      component: () => import('@/views/about') // 懒加载示例
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('@/views/news')
    },
    {
      path: '/news/detail/:id', // 动态路由传参（企业ID）
      name: 'NewsDetail',
      component: () => import('@/views/news-detail')
    },
    {
      path: '/policy',
      name: 'Policy',
      component: () => import('@/views/policy')
    },
    {
      path: '/policy/detail/:id', // 动态路由传参（企业ID）
      name: 'PolicyDetail',
      component: () => import('@/views/policy-detail')
    },
    {
      path: '/services',
      name: 'Services',
      component: () => import('@/views/services'),
    },
    {
      path: '/services/soft',
      name: 'Soft',
      component: () => import('@/views/soft')
    },
    {
      path: '/services/test',
      name: 'Test',
      component: () => import('@/views/test')
    },
    {
      path: '/services/evaluate',
      name: 'Evaluate',
      component: () => import('@/views/evaluate')
    },
    {
      path: '/services/copyright',
      name: 'Copyright',
      component: () => import('@/views/copyright')
    },
    {
      path: '/services/stat',
      name: 'Stat',
      component: () => import('@/views/stat')
    },

    {
      path: '/members',
      name: 'Members',
      component: () => import('@/views/members')
    },
    {
      path: '/members/detail/:id', // 动态路由传参（企业ID）
      name: 'MemberDetail',
      component: () => import('@/views/member-detail')
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/contact')
    },
  ],
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
})
